import { getPath } from '@/router/common'

const baseUrl = {
  title: 'KPI管理',
  path: 'KPImanage'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'KPImanage_Index',
    component: () => import(/* webpackChunkName: "KPImanage_Index" */ '@/views/kPImanage/index/index.vue'),
    meta: {
      title: '基础资料设置'
    }
  },
  {
    path: getPath('AddOrEdit', baseUrl),
    name: 'KPImanage_AddOrEdit',
    component: () => import(/* webpackChunkName: "KPImanage_AddOrEdit" */ '@/views/kPImanage/addOrEdit/index.vue'),
    meta: {
      title: '新增修改KPI指标'
    }
  }
]
